<template>
    <google-analytic v-bind:cookie-performance="this.cookiePerformance" v-bind:tracking="this.tracking"></google-analytic>
</template>

<script>

let VueCookies =  require('vue3-cookies')
const { cookies } = VueCookies.useCookies()

export default {
    props: [
        'tracking',
        'cookiePerformance'
    ],
    watch: {
        cookiePerformance(value)
        {              
            this.prependScript();     
        }
    },
    methods: {
        prependScript() {
            if(cookies.isKey('cookie-performance') && this.tracking !== undefined && this.tracking != '') {
                try {

                    let ga = document.createElement('script')
                    ga.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id='+this.tracking);
                    document.head.prepend(ga);

                    let script = document.createElement('script');
                    script.innerHTML = `window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());        
                    gtag('config', "${this.tracking}");`
                    document.head.prepend(script);

                } catch (error) {
                    console.log(error);                    
                }
            }
        }
    }
}
</script>